import { render, staticRenderFns } from "./organization-question-set-add-library-form.vue?vue&type=template&id=bfd497c8"
import script from "./organization-question-set-add-library-form.vue?vue&type=script&lang=js"
export * from "./organization-question-set-add-library-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports